import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit, OnDestroy {
  @Input() public submitOnChange: boolean = false;
  @Input() public submitOnEnter: boolean = false;
  @Input() public isFullWidth: boolean = false;
  @Input() public defaultWidth: number = 358;
  @Input() public isShowClearButton: boolean = true;
  @Input() public clearButtonTooltip: string;
  @Input() public clearButtonIconSrc: string;
  @Input() public formControl: UntypedFormControl;
  // Note: Consumers must use [formControlDirective] instead of [formControl] on this wrapper component.
  // Binding [formControl] to a custom component makes Angular look for a ControlValueAccessor on the
  // component selector and throws NG01203. Accepting the control via a differently named input avoids
  // attaching FormControlDirective to the wrapper itself while still wiring the inner input.
  @Input() set formControlDirective(ctrl: UntypedFormControl) {
    this.formControl = ctrl;
  }
  @Input() public mask: any;
  @Input() public patterns: any;
  @Input() public maskErrorTooltip: string;
  @Input() public id: string;
  @Input() public name: string = 'searchParameter';
  @Input() public placeholder: string;
  @Input() public dropSpecialCharacters: boolean;
  @Input() public iconSrc: string;
  @Input() public showIcon: boolean = true;
  @Input() public isIconSubmittable: boolean = true;
  @Output() public submit: EventEmitter<string> = new EventEmitter<string>();
  @Output() public clear: EventEmitter<void> = new EventEmitter<void>();

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor() {}

  public ngOnInit(): void {
    //Set default width to provided width + margin & width of the clear button if it's set to show
    this.defaultWidth = this.isShowClearButton ? this.defaultWidth + 37 : this.defaultWidth;

    if (this.submitOnChange) {
      this.formControl.valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged(), debounceTime(600)).subscribe((_) => {
        this.onSubmit();
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  public onSubmit(): void {
    this.submit.emit(this.formControl.value);
  }

  public onClear(): void {
    this.formControl.patchValue('', { emitEvent: false });
    this.clear.emit();
  }

  public onInputKeyPress(e: KeyboardEvent): void {
    const enterKey: string = 'Enter';
    if (this.submitOnChange && e.code === enterKey) {
      e.preventDefault();
      return;
    }

    if (this.submitOnEnter && e.code === enterKey) {
      this.submit.emit(this.formControl.value);
    }
  }
}
